define('Born_Eds/js/view/summary/eds-discount',[
    'Magento_Checkout/js/view/summary/abstract-total',
    'Magento_Checkout/js/model/quote',
    'Magento_Catalog/js/price-utils',
    'Magento_Checkout/js/model/totals'
], function (Component, quote, priceUtils, totals) {
    'use strict';

    return Component.extend({
        defaults: {
            template: 'Born_Eds/summary/eds-discount'
        },

        totals: quote.getTotals(),
        /**
         * @override
         *
         * @returns {Boolean}
         */
        isDisplayed : function() {
            return window.checkoutConfig.eds.active && Math.abs(totals.getSegment('eds_discount').value) > 0;
        },
        getLabel : function() {
            var title = window.checkoutConfig.eds.title;
            if (this.totals()) {
                title = totals.getSegment('eds_discount').title !== '' ?
                    totals.getSegment('eds_discount').title : title;
            }
            return title;
        },
        getValue : function() {
            var price = 0;
            if (this.totals()) {
                price = totals.getSegment('eds_discount').value;
            }
            return this.getFormattedPrice(price);
        }
    });
});

